import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { RecognitionSection } from '../components/RecognitionSection';
import { TruthSection } from '../components/TruthSection';
import { MechanismSection } from '../components/MechanismSection';
import { ProductSection } from '../components/ProductSection';
import { ResultsSection } from '../components/ResultsSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function SalesPage() {
  useEffect(() => {
    // Load Meta Pixel script
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    window.fbq('init', '1664298914738247');
    window.fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen bg-[#1B2838] text-[#F5E6D0] overflow-x-hidden selection:bg-[#E8614D] selection:text-white" data-id="element-181">
      <HeroSection data-id="element-182" />
      <RecognitionSection data-id="element-183" />
      <TruthSection data-id="element-184" />
      <MechanismSection data-id="element-185" />
      <ProductSection data-id="element-186" />
      <ResultsSection data-id="element-187" />
      <FAQSection data-id="element-188" />
      <FinalCTA data-id="element-189" />
      <Footer data-id="element-190" />
    </main>;
}